// extracted by mini-css-extract-plugin
export default {"newsPage":"NewsPage_newsPage__k+c88","newsList":"NewsPage_newsList__pdaaD"};